import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { formatApiErrorDetail } from "@/lib/api";
import { YazturLogo } from "@/components/Brand";
import { ShieldAlert, ArrowLeft } from "lucide-react";

/** Yedek admin girişi — SMS OTP kullanılamadığında (Netgsm arızası, telefon
 * kaybı vb.) kullanılır. URL kasıtlı olarak bilinir değildir; navigasyon
 * menüsünde yer almaz.
 */
export default function AdminEmergency() {
  const { loginWithPassword } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const data = await loginWithPassword(username.trim().toLowerCase(), password);
      toast.success(`Yedek giriş — ${data.name}`);
      if (data.role === "data_entry") navigate("/veri-giris");
      else if (data.role === "viewer") navigate("/is-emirleri");
      else navigate("/dashboard");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-between items-center">
          <YazturLogo size={44} dark />
          <Link to="/login" className="text-xs text-slate-400 hover:text-white flex items-center gap-1">
            <ArrowLeft className="w-3 h-3" /> SMS Girişine Dön
          </Link>
        </div>
        <form
          onSubmit={submit}
          data-testid="admin-emergency-form"
          className="bg-white rounded-lg shadow-2xl border border-amber-400/20 p-8"
        >
          <div className="flex items-center gap-3 mb-6 pb-4 border-b border-slate-100">
            <div className="w-10 h-10 rounded-md bg-amber-50 text-amber-700 flex items-center justify-center">
              <ShieldAlert className="w-5 h-5" />
            </div>
            <div>
              <div className="text-[10px] font-mono uppercase tracking-[0.25em] text-amber-700">Yedek Kanal</div>
              <h2 className="font-heading text-xl font-bold text-slate-900">Acil Yönetici Girişi</h2>
            </div>
          </div>
          <p className="text-xs text-slate-500 mb-6 leading-relaxed">
            SMS servisi çalışmadığında yalnızca yönetici hesabı bu ekrandan girer. Bu URL menüde görünmez ve gizli tutulmalıdır.
          </p>
          <div className="space-y-4">
            <div>
              <Label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Kullanıcı Adı</Label>
              <Input
                data-testid="emergency-username-input"
                type="text"
                autoComplete="username"
                autoCapitalize="none"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="mt-1 h-11 font-mono"
              />
            </div>
            <div>
              <Label className="text-xs font-medium text-slate-600 uppercase tracking-wider">Şifre</Label>
              <Input
                data-testid="emergency-password-input"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="mt-1 h-11"
              />
            </div>
            <Button
              type="submit"
              disabled={busy}
              data-testid="emergency-submit-btn"
              className="w-full h-11 bg-amber-600 hover:bg-amber-700 text-white"
            >
              {busy ? "Giriş yapılıyor..." : "Yedek Kanaldan Giriş"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
